import { client } from '../client';
import { Dependent } from './types/Dependent';

export const getDependentById = async (user_id: number, dependent_id: number): Promise<Dependent> => {
  const { data } = await client.get(`/users/${user_id}/dependents/${dependent_id}`);

  return data;
};
